import * as React from 'react';
import { styles } from './styles';

export class MarketingPage extends React.Component<{}, {}> {
  render() {
    return <div className={styles.contentWrapper}>Welcome to withjoy!</div>;
  }
}
